import Vue from 'vue';
import { constant } from '@/utils/helper';
Vue.mixin({
  data: function () {
    return {
      ...constant
    }
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    isStockItem(article) {
      return this.$store.getters.isStockItem(article);
    },
    getMap(mapName, noAutoLoad = false) {
      return this.$store.getters.getMap(mapName, noAutoLoad);
    },
    getArray(
      mapName,
      noAutoLoad = false,
      byLocation = false,
      destroyClone = true,
      sort = false,
      masterDefault = false
    ) {
      if(mapName != 'locations') {
        return this
                .$store
                .getters
                .getArray(
                  mapName,
                  noAutoLoad,
                  byLocation,
                  destroyClone,
                  sort,
                  masterDefault
                );
      }
      const user = this.$store.getters.getMap('user', true);
      return this
              .$store
              .getters
              .getArray('locations')
              .filter(
                location => user.subLocations.indexOf(location.id) != -1 || user.id == 1
              );
    },
    getObject(value, mapName, property = 'id', noDeleted = false) {
      if(!value && value != 0) {
        return null;
      }
      return this.$store.getters.getObject(value, mapName, property, noDeleted);
    },
    printProperty(objectId, property, mapName, defaultValue = null) {
      const object = this.getObject(objectId, mapName);
      if(!object || (!object[property] && object[property] != 0)) return defaultValue || '...';
      return object[property];
    },
    printName(objectId, mapName, defaultValue = null) {
      return this.printProperty(objectId, 'name', mapName, defaultValue);
    },
    printDate(date, format = 'DD/MM/YYYY HH:mm') {
      if (!date) {
        return '';
      }
      if (typeof date === 'string') {
        date = date.replace(' ', 'T');
      }
      return this.$moment(date).format(format);
    },
    printDateDefaultFormat(date) {
      return this.printDate(date, this.DATE_FORMAT);
    },
    printTime(time) {
      if (!time) {
        return '';
      }
      if (time.length < 9) {
        return time.slice(0, 5);
      }
      return this.printDate(time, 'HH:mm');
    },
    getColor(mapInfo) {
      return this.getMap('colors')[mapInfo];
    },
    convertToArray(str, delimiter = ',') {
      return (str && typeof str === 'string') ? str.split(delimiter) : str;
    },
    convertToString(arr, delimiter = ',') {
      return (arr && typeof arr !== 'string') ? arr.join(delimiter) : arr;
    },
    detach(element, array) {
      const index = array.indexOf(element);
      if(index != -1) array.splice(index, 1);
    },
    printBoolean(value) {
      return value ? this.$gettext('yes') : this.$gettext('no')
    },
    getStartTime(date) {
      return this.$moment(date).startOf('day').format(this.DATE_TIME_FORMAT);
    },
    getEndTime(date) {
      return this.$moment(date).endOf('day').format(this.DATE_TIME_FORMAT);
    },
    can(permission) {
      const permissions = this.getMap('user', true)['permissions'];
      if(!permissions) return false;
      return permissions.includes(this.camelToSnake(permission));
    },
    camelToSnake(string) {
       var result = string.replace(/([A-Z])/g, " $1" );
       return result.split(' ').join('_').toLowerCase();
    },
    getCloneList(map) {
      return this.$store.getters.getCloneList(map);
    },
    getClone(object, map, list = null) {
      return this.$store.getters.getClone(object, map, list);
    },
  }
});
